import { Component } from 'react';

export default class Categories extends Component {
	constructor(props){
		super();
		this.state = {
			categories: {}
		}
	}
	componentDidMount(){
		fetch('http://caseymoir.com/categories.json').then(response => response.json()).then(data => {
			this.setState({ categories: data });
		});
	}
	render(){
		if(typeof this.state.categories === 'object' && this.state.categories !== null && Object.keys(this.state.categories).length > 0){
			return (
				<div className="categories">
					<ul>
						{this.state.categories.map((item) =>
							<li key={item.id} id={item.id} className={this.props.selected === item.name ? 'active' : ''} onClick={() => this.props.changeCat(item.name)}>{item.name}</li>
						)}
					</ul>
				</div>
			);
		}else {
			return null;
		}
	}
}